<template>
  <page-header-wrapper>
    <!-- 全局加载遮罩 -->
    <LoadingMask :visible="showLoadingMask" :text="loadingText" />

    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper"></div>
      <div class="table-operations">
        <a-button type="primary" @click="handleUpdate(0)" v-hasPermi="['sms:template:add']">
          <a-icon type="plus" />新增</a-button
        >
      </div>
      <!-- <div>

      </div> -->
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="code" slot-scope="text, record">
          <dict-tag :options="dict.type['extra_sms_channel']" :value="record.code" />
        </span>
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_normal_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          <span>{{ parseTime(record.createTime, '{y}-{m}-{d}') }}</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleUpdate(record, undefined)" v-hasPermi="['extra:channel:edit']">
            <!-- <a-icon type="edit" /> -->
            修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleShowAccount(record)" v-hasPermi="['extra:channel:query']">
            <!-- <a-icon type="diff" /> -->
            模板
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParams.pageNum"
        :total="total"
        :page-size="queryParams.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <a-modal
        title="选择企业品牌"
        :width="1200"
        :visible="showTenantModal"
        @ok="handleTenantSelect"
        @cancel="showTenantModal = false"
        :confirmLoading="tenantModalLoading"
      >
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="企业名称">
                  <a-input v-model="tenantQuery.name" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="tenantQuery.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="tenantQuery.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 异常关闭 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleTenantQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetTenantQuery"><a-icon type="redo" />重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          :loading="tenantLoading"
          rowKey="id"
          :columns="tenantColumns"
          :data-source="tenantList"
          :pagination="tenantPagination"
          @change="handleTenantTableChange"
          :row-selection="{
            type: 'radio',
            selectedRowKeys: selectedTenantKeys,
            onChange: onTenantSelectChange,
          }"
          :scroll="{ x: 800 }"
          @rowClick="handleTenantRowClick"
          :customRow="customTenantRow"
        >
          <span slot="name" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.name">
              <span class="text-ellipsis">{{ record.name }}</span>
            </a-tooltip>
          </span>
          <span slot="contacts" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.contacts">
              <span class="text-ellipsis">{{ record.contacts }}</span>
            </a-tooltip>
          </span>
          <span slot="mobile" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.mobile">
              <span class="text-ellipsis">{{ record.mobile }}</span>
            </a-tooltip>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-tag :color="record.status === 0 ? 'green' : 'red'">
              {{ record.status === 0 ? '正常' : '异常关闭' }}
            </a-tag>
          </span>
          <span slot="createTime" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.createTime">
              <span class="text-ellipsis">{{ record.createTime }}</span>
            </a-tooltip>
          </span>
        </a-table>
      </a-modal>
    </a-card>

    <a-drawer :maskClosable="false" :visible.sync="open" width="35%" @close="cancel">
      <a-divider orientation="left">
        <b>{{ title }}</b>
      </a-divider>

      <a-form-model ref="form" :model="form" :rules="formRules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="短信签名" prop="signature">
          <a-input v-model="form.signature" placeholder="请输入短信签名" />
        </a-form-model-item>
        <template v-if="!form.id">
          <a-form-model-item label="企业品牌" prop="tenantId">
            <a-input
              placeholder="请选择企业品牌"
              v-model="selectedTenantName"
              read-only
              style="width: 100%"
              allow-clear
              @click="showTenantModal = true"
            >
              <a-icon slot="suffix" type="search" @click="showTenantModal = true" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item label="渠道" prop="code">
            <a-select
              show-search
              :allowClear="true"
              v-model="form.code"
              placeholder="请选择渠道"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option value="ZRWINFO">‌掌榕</a-select-option>
              <!-- <a-select-option value="ALIYUN">阿里云</a-select-option>
              <a-select-option value="TENCENT">腾讯</a-select-option>
              <a-select-option value="DEBUG_DING_TALK">钉钉</a-select-option> -->
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="默认api" prop="defaultKeyAppId">
            <a-radio-group v-model="form.defaultKeyAppId">
              <a-radio-button :value="true"> 是 </a-radio-button>
              <a-radio-button :value="false"> 否 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="API的账号" prop="apiKey" v-if="!form.defaultKeyAppId">
            <a-input v-model="form.apiKey" placeholder="请输入短信 API 的账号" />
          </a-form-model-item>
          <a-form-model-item label="API的密钥" prop="apiSecret" v-if="!form.defaultKeyAppId">
            <a-input v-model="form.apiSecret" placeholder="请输入短信 API 的密钥" />
          </a-form-model-item>
          <a-form-model-item label="签名已加" prop="signaturePartiesAreAdded">
            <a-radio-group v-model="form.signaturePartiesAreAdded">
              <a-radio-button :value="true"> 是 </a-radio-button>
              <a-radio-button :value="false"> 否 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="渠道编码" prop="subId">
            <a-input v-model="form.subId" placeholder="请输入渠道编码" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" placeholder="请输入备注" />
          </a-form-model-item>
          <a-form-model-item label="启用状态">
            <a-radio-group v-model="form.status" button-style="solid">
              <!-- <a-radio-button
                v-for="(d, index) in dict.type.sys_normal_disable"
                :key="index"
                :value="parseInt(d.value)"
                >{{ d.label }}</a-radio-button
              > -->
              <a-radio-button :value="1"> 启用 </a-radio-button>
              <a-radio-button :value="0"> 停用 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </template>
        <!-- <a-form-model-item label="备注" prop="remark">
          <a-input v-model="form.remark" placeholder="请输入备注" />
        </a-form-model-item> -->
      </a-form-model>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" @click="submitForm">确 定</a-button>
          <a-button @click="cancel">取 消</a-button>
        </a-space>
      </div>
    </a-drawer>
  </page-header-wrapper>
</template>
<style scoped lang="less">
.app-container-card {
  margin-top: 10em;
  .bottom {
    margin-top: 13px;
    line-height: 12px;
    text-align: center;
  }
  .content {
    font-size: 12px;
    text-align: center;
  }
}
</style>

<script>
import { listChannel, simpleList, getChannel, delChannel, addChannel, updateChannel } from '@/api/sms/channel'
import { crateAccount, getSmsSetMeal } from '@/api/sms/zrwinfo'
import { listTenant } from '@/api/system/tenant'

import { tableMixin } from '@/store/table-mixin'
import LoadingMask from '@/components/LoadingMask.vue'
export default {
  name: 'Channel',
  mixins: [tableMixin],
  components: {
    LoadingMask,
  },
  dicts: ['sys_normal_disable', 'extra_sms_channel'],
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      zrid: '',
      accountOpen: false,
      userList: [],
      accountTitle: '',
      accountForm: {},
      tenantList: [],
      accountRules: {
        nickname: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        mobile: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
      },
      showCard: true,
      showList: false,
      noZrAccount: false,
      showLoading: false,
      // 全局加载遮罩状态
      showLoadingMask: false,
      loadingText: '',
      // 企业品牌选择相关
      selectedTenantName: '',
      selectedTenantKeys: [],
      selectedTenant: null,
      showTenantModal: false,
      tenantModalLoading: false,
      tenantList: [],
      tenantLoading: false,
      tenantPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      tenantQuery: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contacts: null,
        status: null,
        type: 1, // 厂商
      },
      tenantColumns: [
        {
          title: '企业名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center',
          width: '200px',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '联系人',
          dataIndex: 'contacts',
          align: 'center',
          width: '120px',
          scopedSlots: { customRender: 'contacts' },
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          align: 'center',
          width: '130px',
          scopedSlots: { customRender: 'mobile' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: '100px',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: '150px',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 短信渠道（阿里，腾讯，钉钉等）表格数据
      list: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        signature: null,
        code: null,
        status: 0,
        apiKey: null,
        apiSecret: null,
        callbackUrl: null,
        isDeleted: null,
        signaturePartiesAreAdded: true,
        subId: undefined,
      },
      // 表单参数
      form: {
        status: 1,
        defaultKeyAppId: false,
      },
      columns: [
        // {
        //   title: '编号',
        //   dataIndex: 'id',
        //   align: 'center',
        // },
        {
          title: '短信签名',
          dataIndex: 'signature',
          ellipsis: true,
          width: 200,
          align: 'center',
        },
        {
          title: '渠道编码',
          dataIndex: 'code',
          // scopedSlots: { customRender: 'code' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '启用状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList(true)
    this.getTenantList()
  },
  watch: {
    // 监听企业品牌模态框显示状态
    showTenantModal(newVal) {
      if (newVal && this.tenantList.length > 0) {
        // 初始化选中状态
        if (this.form.tenantId) {
          this.selectedTenantKeys = [this.form.tenantId]
          const selected = this.tenantList.find((item) => item.id === this.form.tenantId)
          if (selected) {
            this.selectedTenant = selected
            this.selectedTenantName = selected.name
          }
        } else {
          this.selectedTenantKeys = []
          this.selectedTenant = null
        }
      }
    },
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    formRules() {
      return {
        tenantId: [
          {
            required: true,
            message: '企业品牌不能为空',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              // 只在新增模式下验证企业品牌必填
              // 检查 form.tenantId 的值，确保验证正确
              const tenantId = value !== undefined ? value : this.form.tenantId
              if (!this.form.id && !tenantId) {
                callback(new Error('企业品牌不能为空'))
              } else {
                callback()
              }
            },
          },
        ],
        subId: [{ required: true, message: '三方签名编码不能为空', trigger: 'blur' }],
        signature: [{ required: true, message: '短信签名不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '渠道编码不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '开启状态不能为空', trigger: 'blur' }],
        apiKey: [
          {
            required: true,
            message: '短信API的账号不能为空',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // 只在非默认使用短信时验证API账号必填
              if (!this.form.defaultKeyAppId && !value) {
                callback(new Error('短信API的账号不能为空'))
              } else {
                callback()
              }
            },
          },
        ],
        apiSecret: [
          {
            required: true,
            message: '短信API的密钥不能为空',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // 只在非默认使用短信时验证API密钥必填
              if (!this.form.defaultKeyAppId && !value) {
                callback(new Error('短信API的密钥不能为空'))
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },
  methods: {
    handleAddAccount() {
      this.accountReset()
      this.accountOpen = true
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    submitAccountForm() {
      this.$refs['accountForm'].validate((valid) => {
        if (valid) {
          crateAccount(this.accountForm).then((response) => {
            if (response.code === 1) {
              this.accountOpen = false
              this.$message.success('申请成功')
            } else {
              this.$message.error(response.msg)
            }
            this.getList(true)
          })
        }
      })
    },
    cancelAccount() {
      this.accountOpen = false
      this.accountReset()
    },
    accountReset() {
      this.accountForm = {
        nickname: null,
        mobile: null,
        password: null,
        remark: null,
        signaturePartiesAreAdded: true,
      }
      this.resetForm('accountForm')
    },
    handleShowAccount(e) {
      this.$router.push({
        path: '/sms/zrw-info/index/' + e.id,
      })
    },
    handleShowList() {
      this.showList = true
      this.showCard = false
      this.getList(false)
    },
    handleShowCard() {
      this.showList = false
      this.showCard = true
    },
    /** 查询短信渠道（阿里，腾讯，钉钉等）列表 */
    getList(createFlag) {
      this.loading = true

      if (this.userType == 0) {
        listChannel().then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
          let zrCount = 0
          if (createFlag) {
            this.list.map((item) => {
              if (item.code === 'ZRWINFO') {
                zrCount = zrCount + 1
                this.zrid = item.id
              }
            })
            if (zrCount > 0) {
              this.showList = true
              this.showCard = false
              this.noZrAccount = false
            } else {
              this.showList = false
              this.showCard = true
              this.noZrAccount = true
            }
          }
        })
      } else {
        simpleList().then((response) => {
          this.list = response.data
          this.total = response.data.total
          this.loading = false
          let zrCount = 0
          this.columns.splice(2, 3)

          if (createFlag) {
            this.list.map((item) => {
              if (item.code === 'ZRWINFO') {
                zrCount = zrCount + 1
                this.zrid = item.id
              }
            })
            if (zrCount > 0) {
              this.showList = true
              this.showCard = false
              this.noZrAccount = false
            } else {
              this.showList = false
              this.showCard = true
              this.noZrAccount = true
            }
          }
        })
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.showLoading = false
      this.hideLoadingMask()
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        signature: null,
        code: 'ZRWINFO', // 默认选择掌榕
        status: 1,
        remark: null,
        apiKey: null,
        apiSecret: null,
        callbackUrl: null,
        signaturePartiesAreAdded: true,
        subId: undefined,
        defaultKeyAppId: false,
      }

      // 清除所有表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })

      // 重置企业品牌选择状态
      this.selectedTenantName = ''
      this.selectedTenantKeys = []
      this.selectedTenant = null
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTent() {
      listTenant({ type: 1, pageSize: 100 }).then((res) => {
        if (res.code === '20001') {
          this.userList = res.data.records
          // 如果form中有tenantId，设置显示名称
          if (this.form.tenantId && this.userList.length > 0) {
            const tenant = this.userList.find((item) => item.id === this.form.tenantId)
            if (tenant) {
              this.selectedTenantName = tenant.name
            }
          }
        }
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '添加短信渠道'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.showLoading = false
      this.hideLoadingMask()
      if (row) {
        const id = row.id || this.ids
        getChannel(id).then((response) => {
          this.form = response.data
          // 如果有tenantId，设置显示名称
          if (this.form.tenantId && this.tenantList.length > 0) {
            const tenant = this.tenantList.find((item) => item.id === this.form.tenantId)
            if (tenant) {
              this.selectedTenantName = tenant.name
            }
          }
          this.open = true
          this.title = '修改短信渠道'
        })
      } else {
        this.open = true
        this.title = '添加短信渠道'
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid, object) => {
        if (valid) {
          this.setLoadingMask('正在提交数据...')
          if (this.form.id != null) {
            const query = {
              signature: this.form.signature,
              id: this.form.id,
            }
            updateChannel(query)
              .then((response) => {
                if (response.code === '20001') {
                  this.hideLoadingMask()
                  this.$message.success('修改成功')
                  this.showLoading = false
                  this.open = false
                  this.getList(true)
                } else {
                  this.hideLoadingMask()
                  this.$message.error(response.message)
                  this.showLoading = false
                }
              })
              .catch(() => {
                this.hideLoadingMask()
                this.showLoading = false
              })
          } else {
            addChannel(this.form)
              .then((response) => {
                if (response.code === '20001') {
                  this.hideLoadingMask()
                  this.$message.success('新增成功')
                  this.showLoading = false
                  this.open = false
                  this.getList(true)
                } else {
                  this.hideLoadingMask()
                  this.$message.error(response.message)
                  this.showLoading = false
                }
              })
              .catch(() => {
                this.hideLoadingMask()
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.hideLoadingMask()
          // 显示表单验证错误消息
          this.$message.error(messages.join('；'))
          return false
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$modal
        .confirm('是否确认删除短信渠道为"' + ids + '"的数据项？')
        .then(function () {
          return delChannel(ids)
        })
        .then((response) => {
          if (response.success) {
            this.getList()
            this.$message.success('删除成功')
          } else {
            this.$message.error(response.message)
          }
        })
        .catch(() => {})
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        'extra/channel/export',
        {
          ...this.queryParams,
        },
        `channel_${new Date().getTime()}.xlsx`
      )
    },
    onShowSizeChange(current, pageSize) {
      this.queryParams.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParams.pageNum = current
      this.queryParams.pageSize = pageSize
      this.getList()
    },
    // 企业品牌选择相关方法
    getTenantList() {
      this.tenantLoading = true
      listTenant(this.tenantQuery)
        .then((res) => {
          if (res.code === '20001') {
            this.tenantList = res.data.records
            this.tenantPagination.total = res.data.total
            this.tenantPagination.current = res.data.current

            // 如果form中有tenantId，同步设置显示名称
            if (this.form.tenantId && this.tenantList.length > 0) {
              const tenant = this.tenantList.find((item) => item.id === this.form.tenantId)
              if (tenant) {
                this.selectedTenantName = tenant.name
              }
            }
          }
          this.tenantLoading = false
        })
        .catch(() => {
          this.tenantLoading = false
        })
    },
    handleTenantQuery() {
      this.tenantQuery.pageNum = 1
      this.getTenantList()
    },
    resetTenantQuery() {
      this.tenantQuery = {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contacts: null,
        status: null,
        type: 1,
      }
      this.getTenantList()
    },
    handleTenantTableChange(pagination) {
      this.tenantQuery.pageNum = pagination.current
      this.tenantQuery.pageSize = pagination.pageSize
      this.getTenantList()
    },
    onTenantSelectChange(selectedRowKeys, selectedRows) {
      this.selectedTenantKeys = selectedRowKeys
      this.selectedTenant = selectedRows[0] || null
    },
    handleTenantSelect() {
      if (!this.selectedTenant) {
        this.$message.warning('请选择一个企业品牌')
        return
      }

      this.form.tenantId = this.selectedTenant.id
      this.selectedTenantName = this.selectedTenant.name
      this.showTenantModal = false

      // 重新验证企业品牌字段，确保验证通过
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('tenantId', () => {})
        }
      })
    },
    handleTenantRowClick(record) {
      this.selectedTenantKeys = [record.id]
      this.selectedTenant = record

      // 自动关闭弹框并设置选中值
      this.form.tenantId = record.id
      this.selectedTenantName = record.name
      this.showTenantModal = false

      // 重新验证企业品牌字段，确保验证通过
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('tenantId', () => {})
        }
      })
    },
    customTenantRow(record) {
      return {
        on: {
          click: () => {
            this.handleTenantRowClick(record)
          },
        },
        style: {
          cursor: 'pointer',
        },
      }
    },
    // LoadingMask 控制方法
    setLoadingMask(text = '正在处理中...') {
      this.showLoadingMask = true
      this.loadingText = text
    },
    hideLoadingMask() {
      this.showLoadingMask = false
      this.loadingText = ''
    },
  },
}
</script>
<style lang="less" scoped>
.loading_Spin {
  width: 38%;
}
</style>
